import { UAParser } from 'ua-parser-js';
import appendFormFields from './append-form-fields';

type BrowserDataType = 'login' | 'register' | 'help-request';

interface BrowserDataLogin {
    bi_browser: string | undefined;
    bi_browserver: string | undefined;
    bi_os: string | undefined;
    bi_osver: string | undefined;
    bi_device?: string;
    bi_viewport?: string;
    bi_pixratio?: number;
    bi_deviceres?: string;
    bi_availres?: string;
}

interface BrowserDataRegister {
    navigator_userAgent: string;
    navigator_appVersion: string | undefined;
    navigator_platform: string | undefined;
    navigator_appName: string | undefined;
    navigator_javaEnabled: boolean;
    navigator_cookieEnabled: boolean;
    navigator_cpuClass: string | undefined;
    navigator_browserLanguage: string;
    screen_availHeight?: number;
    screen_availWidth?: number;
    screen_height?: number;
    screen_width?: number;
    flash_major: number;
    flash_minor: number;
    flash_revision: number;
}

interface BrowserDataHelpRequest {
    javaState: number;
    cookies: string;
    localTime: number;
    screenX?: number;
    screenY?: number;
    screenC?: number;
    Window_Size?: string;
    Page_Size?: string;
}

const createBrowserInfoParameters = (element: string, type: BrowserDataType): void => {
    const form: HTMLFormElement | null = document.querySelector(element);

    if (form) {
        let data;
        switch (type) {
            case 'login':
                data = getBrowserInfoLogin();
                break;
            case 'help-request':
                data = getBrowserInfoHelpRequest();
                break;
            case 'register':
            default:
                data = getBrowserInfoRegister();
                break;
        }

        appendFormFields(data, form);
    }
};

const getBrowserInfoRegister = (): BrowserDataRegister => {
    const parser = new UAParser();
    const cpu = parser.getCPU();
    const userOs = parser.getOS();
    const userBrowser = parser.getBrowser();
    const data: BrowserDataRegister = {
        navigator_userAgent: navigator.userAgent.toLowerCase(),
        navigator_appVersion: userBrowser.version,
        navigator_platform: `${userOs.name} ${userOs.version}`,
        navigator_appName: userBrowser.name,
        navigator_javaEnabled: false,
        navigator_cookieEnabled: navigator.cookieEnabled,
        navigator_cpuClass: cpu.architecture,
        navigator_browserLanguage: navigator.language,
        flash_major: 0,
        flash_minor: 0,
        flash_revision: 0,
    };

    if (window.screen) {
        data.screen_height = window.screen.height;
        data.screen_width = window.screen.width;
        data.screen_availHeight = window.screen.availHeight;
        data.screen_availWidth = window.screen.availWidth;
    }

    return data;
};

const getBrowserInfoLogin = (): BrowserDataLogin => {
    const parser = new UAParser();
    const userOs = parser.getOS();
    const userDevice = parser.getDevice();
    const userBrowser = parser.getBrowser();
    const data: BrowserDataLogin = {
        bi_browser: userBrowser.name,
        bi_browserver: userBrowser.version,
        bi_os: userOs.name,
        bi_osver: userOs.version,
        bi_viewport: `${window.innerWidth}x${window.innerHeight}`,
        bi_pixratio: window.devicePixelRatio,
    };

    if (userDevice && userDevice.vendor && userDevice.model) {
        data.bi_device = `${userDevice.vendor} ${userDevice.model}`;
    }

    if (window.screen) {
        data.bi_deviceres = `${window.screen.width}x${window.screen.height}`;
        data.bi_availres = `${window.screen.availWidth}x${window.screen.availHeight}`;
    }

    return data;
};

const getBrowserInfoHelpRequest = (): BrowserDataHelpRequest => {
    const data: BrowserDataHelpRequest = {
        javaState: 0,
        cookies: document.cookie,
        localTime: Math.round(new Date().getTime() / 1000),
    };

    if (window.screen) {
        data.screenX = window.screen.width;
        data.screenY = window.screen.height;
        data.screenC = window.screen.colorDepth;
        data.Window_Size = `${window.screen.width}x${window.screen.height} (${window.screenX},${window.screenY})`;
        data.Page_Size = `${window.screen.availWidth}x${window.screen.availHeight}`;
    }

    return data;
};

export default createBrowserInfoParameters;
